<template>
<div>
  <v-card-title>{{manifest_id}}</v-card-title>
  <v-simple-table>
    <thead>
      <tr v-if="received">
        <td colspan="5">
          <v-alert type="info" dense>This manifest has been received already, you can move to the next step.</v-alert>
        </td>
      </tr>
      <tr>
        <th>Exists?</th>
        <th>Lot</th>
        <th>Type</th>
        <th>Sample Name</th>
        <th>Inventory Name</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in samples">
        <td>
          <v-checkbox v-model="item.exists" :disabled="received" dense></v-checkbox>
        </td>
        <td>{{item.lot}}</td>
        <td>{{item.type}}</td>
        <td>{{item.name}}</td>
        <td>{{item.inventory_name}}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="5">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="submit" :disabled="loading" :loading="loading">Submit</v-btn>
          </v-card-actions>
        </td>
      </tr>
    </tfoot>
  </v-simple-table>
</div>
</template>

<script>
import trace from '@/Lib/Tracability'
export default {
    name: "StepVerifyPresence",
    components: {},
    props:{
      manifest_items:{
        required: true,
      },
      manifest_id:{
        required: true,
      },
      received:{
        default: false,
        type: Boolean
      }
    },
    data: () => ({
      samples: [],
      loading: false,
    }),
    watch:{
      manifest_items(v){
        this.samples = this.mapManifest();
      }
    },
    mounted(){
      this.samples = this.mapManifest();
    },
    methods: {
      async submit(){
        this.loading =true;
        if(this.received){
          this.$emit('next');
          return;
        }else{
          let missingSamples = this.samples.filter(sample => !sample.exists);
          if(missingSamples.length === 0){
            missingSamples = false;
          }
          let receivedManifest = await trace.post(`/manifest/receive/${this.manifest_id}`, {
            missing: missingSamples
          });
          if(receivedManifest.data.validation_messages && receivedManifest.data.validation_messages === "Transfer must have status = in-transit but is received"){
            receivedManifest = await trace.get(`/manifest/get/${this.manifest_id}`);
          }
          this.$emit('received_manifest', receivedManifest.data);
        }
        this.loading = false;
      },
      mapManifest(){
        return this.manifest_items.map(item => {
          return {
            lot: item.global_inventory_id,
            type: item.intermediate_type,
            name: item.strain_name,
            inventory_name: item.inventory_name,
            exists: true,
          }
        })
      }
    }
}
</script>

<style scoped>

</style>
